import { render } from "./SpiritOfJapan2.vue?vue&type=template&id=515eca88&scoped=true"
import script from "./SpiritOfJapan2.vue?vue&type=script&lang=js"
export * from "./SpiritOfJapan2.vue?vue&type=script&lang=js"

import "./SpiritOfJapan2.scss?vue&type=style&index=0&id=515eca88&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-515eca88"]])

export default __exports__